const SpinsPage = () => {
  return <div>Giros</div>
}

export default SpinsPage